const KeenSlider = window.KeenSlider

if (!customElements.get('section-articles')) {
  customElements.define(
    'section-articles',
    class ArticlesCarousel extends window.BAO.CustomElement() {
      constructor () {
        super()

        if (!this.els.slide) return

        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (window.innerWidth > 767) {
          this.els.slides.element.classList.remove('car-Carousel_Slides')

          this.els.slide.elements.forEach(slide => {
            slide.classList.remove('car-Carousel_Slide')
          })

          return
        }

        return new KeenSlider(this.els.slides.element, {
          defaultAnimation: { duration: 1000 },
          mode: 'snap',
          loop: true,
          selector: '.car-Carousel_Slide',
          slides: {
            origin: 'center',
            perView: 1.3,
            spacing: 15,
          },
          slideChanged: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.track.details.rel,
              )
            })
          },
          created: instance => {
            this.setAttribute('data-initialized', 'true')
          },
        })
      }
    },
  )
}
